import { defaultHeaders } from '@/config/defaultHeaders.ts'
import axios from 'axios'
import { AuthToken } from '../types/AuthToken.ts'
import { BrowserStorage } from '@/core/utils/browserStorage.ts'
import { appConfig } from '@/config/app.ts'

export const getStoredTokens = () => {
  return BrowserStorage.readLocalObject<AuthToken>('auth')
}

export const removeStoredTokens = () => {
  BrowserStorage.removeLocal('auth')
}

export const storeTokens = (data: AuthToken) =>
  BrowserStorage.writeLocalObject('auth', data)

export const refreshTokens = async (refreshToken: string) => {
  const apiURL = appConfig.apiUrl
  const apiVersion = appConfig.apiVersion
  const resp = await axios.post<{ token: string }>(
    `${apiURL}/api/${apiVersion}/token/refresh`,
    {
      refresh_token: refreshToken
    },
    {
      headers: {
        ...defaultHeaders
      }
    }
  )
  return resp.data
}

/**
 * Generates an SHA-256 hash of the input message in a browser.
 * @param {string} message The string to hash.
 * @param algorithm The algorithm to use. Defaults to 'SHA-256'.
 * @returns {Promise<string>} The hash as a hexadecimal string.
 */
export const generateHash = async (
  message: string,
  algorithm: string | Algorithm = 'SHA-256'
): Promise<string> => {
  // Encode the string as a Uint8Array (UTF-8 is standard)
  const msgBuffer = new TextEncoder().encode(message)

  // Hash the message using SHA-256
  const hashBuffer = await crypto.subtle.digest(algorithm, msgBuffer)

  // Convert the ArrayBuffer to an array of bytes
  const hashArray = Array.from(new Uint8Array(hashBuffer))

  // Convert bytes to a hexadecimal string
  return hashArray.map((b) => ('00' + b.toString(16)).slice(-2)).join('')
}
